<template>
    <div class="CategoryItem">
        <div class="Frame">
            <div class="CategoryItemImage">               
                <router-link  :to="{ name:'CatalogProducts', params: {idCatalog: this.idCatalogo}}" exact><img :src="this.getUrlImmagineFull(this.urlImmagine,false)" alt="" /></router-link>
            </div>
            <div class="CategoryItemText">{{ this.descrizione}}</div>
            <div class="CategoryItemInfo" v-html="this.descrizioneDettagliata"></div>
            <div class="Button Big CustomColor">
                <router-link  :to="{ name:'CatalogProducts', params: {idCatalog: this.idCatalogo}}" exact>{{ this.risorse["IniziaOrdine"] }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>

import {imgMixin, risorseMixin} from "@/mixin.js";

export default {
    name: "Catalog",
    props:{
        urlImmagine: String,      
        descrizione: String,
        idCatalogo: String,
        descrizioneDettagliata: String
    },
    mixins:[
        imgMixin,
        risorseMixin
    ]
}
</script>
